import { PasswordUtil as PU } from "src/common/util/PasswordUtil";

export class PasswordUtil {

  static getPasswordValidationMessage(password, passwordRules) {
    const getLongestCommonPrefix = (strs) => {
      function isCommonPrefix(tokenArrays, length) {
        const ta = tokenArrays.map(tokens => tokens.slice(0, length).join(" "));
        let last = ta[0];
        for (let i = 1; i < ta.length; ++i) {
          if (ta[i] !== last) {
            return false;
          }
        }
        return true;
      }

      if (strs.length === 0) {
        return "";
      }

      const tokenArrays = strs.map(str => str.split(/\s+/));

      let minLength = Math.min(...tokenArrays.map(tokens => tokens.length));

      let low = 1;
      let high = minLength;
      let longest = 0;

      while (low <= high) {
        let mid = Math.floor((low + high) / 2);
        if (isCommonPrefix(tokenArrays, mid)) {
          longest = mid;
          low = mid + 1;
        } else {
          high = mid - 1;
        }
      }

      if (tokenArrays[0][longest - 1] === "a") { // indefinite article
        --longest;
      }

      return tokenArrays[0].slice(0, longest).join(" ");
    };

    const violations = PU.validate(password, passwordRules);
    const prefix = getLongestCommonPrefix(violations).trim();
    if (violations.length === 0) {
      return null;
    }
    if (violations.length === 1) {
      return violations[0];
    }
    return <p>
      {prefix && prefix + ":"}
      <ul>
        {...violations.map(message => (<li>{message.substring(prefix.length)}</li>))}
      </ul>
    </p>
  }

}